import { REQUEST_LOGS_LIST_SUCCESS} from '../constants/actionTypes';

const INITIAL_STATE = { logsData: {}, errors: null };

export default function logsData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case REQUEST_LOGS_LIST_SUCCESS:
      return { ...state, data: action.payload.data, errors: null }
    default:
      return state;
  }
}
